<template>
  <v-container class="owl-custom-carousel" grid-list-md text-xs-center>
    <h1>{{ msg }}</h1>
    <v-layout row wrap>
      <v-flex sm6 xs12>
        <v-card dark >
          <v-card-text class="px-0">
            <carousel class="slider-demo" :items="items" :margin="margin" :loop="loop" :autoplay="autoplay" :nav="nav" :navText="navText" :data="data">

              <div class="single-slider-carousel" v-for="(item,i) in data" :key="i" >
                <img :src="item.img">
                <div class="single-slider-content">
                  <h2 style="color:#fff;font-size:30px;">{{item.content.title}}</h2>
                  <h3 style="color:#fff;font-size:20px;"><span>{{item.content.subTitle}}</span></h3>
                  <p style="color:#fff;font-size:13px;">
                      {{item.content.para}}
                  </p>
                  <a href="#">{{item.content.tag}}</a>
                </div>
                
              </div>
            </carousel>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

  import carousel from 'vue-owl-carousel'

  export default {
    name: 'OwlCarouel',
    components: { carousel },
    props: {
      msg: String,
      data: {
        type : Array,
        default: () => []
      },
      items: {
        type: Number
      },
      margin: {
        type: Number
      },
      loop: {
        type : Boolean
      },
      autoplay: {
        type : Boolean
      },
      nav : {
        type: Boolean,
        default: false
      },
      navText : {
        type : Array,
        default: () => []
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .theme--dark.v-sheet {
    background-color: transparent;
    border-color: transparent;
    color: #fff;
  }
  .elevation-2 {
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
  }
  .owl-item img {
    height: 350px;
  }
</style>
